import React from "react";
import { applySpec } from "ramda";
import {connect, useDispatch} from "react-redux";
import {getEditMediaLoading, getEditMediaVisible} from "common/selectors";
import PanelLoadingIndicator from "components/PanelLoadingIndicator";
import AddContributorDialog from "edit-media/components/AddContributorDialog";
import EditContributorDialog from "edit-media/components/EditContributorDialog";
import EditMediaActionBar from "edit-media/components/EditMediaActionBar";
import EditMediaHeader from "edit-media/components/EditMediaHeader";
import EditMediaTabs from "edit-media/components/EditMediaTabs";
import styles from "edit-media/components/EditMedia.css";
import RemoveContributorDialog from "edit-media/components/RemoveContributorDialog";
import EditThumbnailDialog from "edit-media/components/EditThumbnailDialog";
import Dialog from "@material-ui/core/Dialog";
import {hideDrawer} from "../redux/editMediaActions";
import Slide from "@material-ui/core/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditMedia = ({ loading, editMediaVisible }) => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideDrawer());
  };

  return (
    <Dialog fullScreen open={editMediaVisible} onClose={handleCancel} TransitionComponent={Transition}>
      <div className={styles.container}>
        <div className={styles.actionBarContainer}>
          <EditMediaActionBar />
        </div>
        <div className={styles.header}>
          <EditMediaHeader />
        </div>
        {loading ? <PanelLoadingIndicator /> : <EditMediaTabs />}
        <AddContributorDialog />
        <EditContributorDialog />
        <RemoveContributorDialog />
        <EditThumbnailDialog />
      </div>
    </Dialog>
)};

const mapStateToProps = applySpec({
  loading: getEditMediaLoading,
  editMediaVisible: getEditMediaVisible,
});

export default connect(mapStateToProps)(EditMedia);
